import { z } from 'zod';
import superjson from 'superjson';
import { ChatMessage } from './list_GET.schema';

export const schema = z.object({
  sessionId: z.string().min(1),
  message: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
  message: ChatMessage;
};

export const sendChatMessage = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/chat/send`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
